/** F-204: the platform's minimum age to have an account. */
export const PLATFORM_MINIMUM_AGE = 16

/** F-204: the highest age a community can ask for. */
export const MAX_MINIMUM_AGE = 99

/** F-204: the age to buy alone (or with a legal guardian's authorization). */
export const PURCHASE_AGE = 18

/** The age a person confirms to have an account here: 16, or the community's higher `minimumAge`. */
export const minimumAgeOf = (community?: { minimumAge?: number | null } | null): number =>
  Math.max(PLATFORM_MINIMUM_AGE, Number(community?.minimumAge) || 0)
